import { booleanAttribute, Component, Input, numberAttribute, ChangeDetectionStrategy } from '@angular/core';
import { IonText } from '@ionic/angular';

import { OneOnOneLanguage } from '@ninety/mobile/platform/api';

@Component({
  selector: 'nty-discussion-form-helper-content',
  imports: [IonText],
  template: `
    <div class="helper-content" [class.negative]="errorCount !== 0">
      @if (readonly) {
        <ion-text>
          You've submitted your {{ language.item }} form! Your responses are available for review, but no edits can be
          made.
        </ion-text>
      } @else if (errorCount === 0) {
        <ion-text>All required questions have been completed on this section.</ion-text>
      } @else {
        <ion-text>{{ errorCount }} of {{ questionCount }} questions still required for this section.</ion-text>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    @use 'terra';

    div.helper-content {
      padding: 8px 24px;
      @include terra.text(body);
      background-color: rgba(72, 152, 75, 0.04);
      border: solid 1px rgba(72, 152, 75, 0.2);
      @include terra.radius(small);
      color: terra.color(text);

      &.negative {
        background-color: rgba(205, 69, 81, 0.04);
        border-color: rgba(205, 69, 81, 0.2);
        color: rgba(176, 59, 70, 1);
      }
    }
  `,
})
export class DiscussionFormHelperContentComponent {
  @Input({ required: true, transform: numberAttribute }) errorCount = 0;
  @Input({ required: true, transform: numberAttribute }) questionCount = 0;
  @Input({ required: true, transform: booleanAttribute }) readonly = true;
  @Input({ required: true }) language!: OneOnOneLanguage;
}
